import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save, Info } from "lucide-react";

export default function Pricing() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/admin/pricing").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return <div className="text-gray-400">Yükleniyor...</div>;

  const save = async () => {
    try {
      await api.put("/admin/pricing", {
        global_markup_percent: Number(p.global_markup_percent),
        provider_rate_multiplier: Number(p.provider_rate_multiplier),
        category_markups: p.category_markups || {},
      });
      toast.success("Fiyatlandırma kaydedildi");
    } catch { toast.error("Hata"); }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-extrabold text-white mb-6">Fiyatlandırma</h1>
      <div className="card-surface p-6 space-y-5">
        <div className="flex items-start gap-2 bg-blue-500/10 text-blue-300 text-sm rounded-xl p-4">
          <Info size={18} className="shrink-0 mt-0.5" />
          <span>Satış fiyatı = JungleSMM alış fiyatı × Kur Çarpanı × (1 + Kâr%). Fiyat hesaplamaları backend'de yapılır, frontend'den değiştirilemez.</span>
        </div>
        <div>
          <label className="text-sm text-gray-300 font-medium">Global Kâr Yüzdesi (%)</label>
          <input type="number" value={p.global_markup_percent} onChange={(e) => setP({ ...p, global_markup_percent: e.target.value })}
            className="w-full bg-[#171922] border border-white/10 rounded-xl px-4 py-3 text-white mt-2" data-testid="global-markup-input" />
          <p className="text-xs text-gray-500 mt-1">Örn: 30 → alış 100₺ ise satış 130₺</p>
        </div>
        <div>
          <label className="text-sm text-gray-300 font-medium">Kur Çarpanı (USD→TL)</label>
          <input type="number" step="0.01" value={p.provider_rate_multiplier} onChange={(e) => setP({ ...p, provider_rate_multiplier: e.target.value })}
            className="w-full bg-[#171922] border border-white/10 rounded-xl px-4 py-3 text-white mt-2" data-testid="multiplier-input" />
          <p className="text-xs text-gray-500 mt-1">JungleSMM fiyatları USD ise, TL'ye çevirmek için güncel kuru girin (örn: 41). USD kullanmıyorsanız 1 bırakın.</p>
        </div>
        <button onClick={save} className="btn-gradient px-6 py-3 rounded-xl font-bold flex items-center gap-2" data-testid="save-pricing-btn"><Save size={16} /> Kaydet</button>
      </div>
    </div>
  );
}
